export const OBG_EXPERIMENTS_HEADER_NAME = "X-OBG-EXPERIMENTS";
export const OBG_EXPERIMENTS_SOURCE = "obg-experiments";

export const OBG_EXPERIENCE_HEADER_NAME = "X-OBG-EXPERIENCE";
export const OBG_EXPERIENCE_SOURCE = "obg-experience";
